<template>
  <v-app>
    <dashboard-core-app-bar />
    <dashboard-core-drawer v-if="user" />
    <dashboard-core-view />
  </v-app>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    computed: {
      ...mapState({
        user: state => state.user.user,
      }),
    },

    data: () => ({
      expandOnHover: false,
      overlay: process.env.VUE_APP_SOFTLAUNCH_MODE === "true",
    }),
  }
</script>
